"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nodeType = exports.UiConfigSchema = exports.TaskSchema = void 0;
const zod_1 = require("zod");
const tape_sanitizer_1 = require("@finley-technologies/tape-sanitizer");
exports.TaskSchema = zod_1.z.discriminatedUnion('mode', [
    tape_sanitizer_1.PyXlsx2Csv2ConvertRangeSchema.extend({
        srcArtifactSlug: zod_1.z.string(),
    }),
    tape_sanitizer_1.PyXlsx2Csv2ExtractValuesSchema.extend({
        srcArtifactSlug: zod_1.z.string(),
    }),
]);
exports.UiConfigSchema = zod_1.z.discriminatedUnion('mode', [
    tape_sanitizer_1.PyXlsx2Csv2ConvertRangeSchema,
    tape_sanitizer_1.PyXlsx2Csv2ExtractValuesSchema,
]);
exports.nodeType = 'operation_pyXlsx2csv2';
//# sourceMappingURL=types.js.map